<div class="px-0 px-lg-2 px-xl-5 py-3">
  <div class="d-flex h-100 w-100 shadow rounded-3 p-3"
    style="backdrop-filter: blur(10px);background: rgba(255, 255, 255, 0.8);">

    <div class="w-100">
      <div class="w-100 shadow-sm">
        <div class="card-header bg-white py-3">
          <h5 class="mb-0 fw-bold text-primary" style="color: #008A70 !important;">
            <i class="fas fa-tasks me-2"></i>Pending Evaluations
          </h5>
        </div>

        <div class="w-100">
          <div class="table-responsive">
            <table class="table table-hover align-middle mb-0"> 
              <thead>
                <tr>
                  <th style="background: #C5E2DA;color: #205567;" class="fw-bold">User ID</th>
                  <th style="background: #C5E2DA;color: #205567;" class="fw-bold">Test Type</th>
                  <th style="background: #C5E2DA;color: #205567;" class="fw-bold">Files</th>
                  <th style="background: #C5E2DA;color: #205567;" class="fw-bold">Designer Comments</th>
                  <th style="background: #C5E2DA;color: #205567;" class="fw-bold text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let userId of objectKeys(groupedTasks)">
                  <td>
                    <span class="customPreActivatedButtons">{{ userId }}</span>
                  </td>
                  <td>
                    <span [class]="'badge ' + groupedTasks[userId][0].badgeClass">
                      {{ getTierName(groupedTasks[userId][0].assementId) }}
                    </span>
                  </td>
                  <td>
                    <button class="customPreActivatedButtons" (click)="downloadAllFiles(groupedTasks[userId])">
                      <i class="fas fa-download me-1"></i>Download Files ({{ groupedTasks[userId].length }})
                    </button>
                  </td>
                  <td>
                    {{ groupedTasks[userId][0].reviewComment }}
                  </td>
                  <td class="text-center">
                    <div class="btn-group" role="group">
                      <button type="button" class="customeSkillButtons btn-sm savebutton" (click)="approve(userId)">
                        <i class="fas fa-check me-1"></i>Approve
                      </button>
                      <button type="button" class="btn btn-outline-danger btn-sm canclebutton" (click)="Reject(userId)">
                        <i class="fas fa-times me-1"></i>Reject
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>